<template>
<div class="notfound">
    <div class="notfound-cont">
      <img :src="require('./images/404-ico.png')" height="128" alt="">
      <div class="notfound-note">
        <div class="main">404</div>
        <div class="subf">没有找到你想要的页面…</div>
        <div class="control"><router-link to="/">返回首页</router-link></div>
      </div>
    </div>
</div>
</template>
<script>
export default {
  name: 'NotFound',
};
</script>
<style lang="scss" scoped>
.notfound{
  display: flex; justify-content: center; padding-top: 300px;
  .notfound-cont{
    display: flex;
    .notfound-note{
      margin-left:45px; white-space: nowrap;
      .main{font-size: 40px; line-height: 40px;margin-bottom: 10px;}
      .subf{font-size: 16px; line-height: 24px; color: #ACAFB2; margin-bottom: 15px;}
      .control a{
        display: inline-block; line-height: 40px; padding: 0 20px; background: #e43a3a; color: #fff; border-radius: 4px;
        &:hover{opacity: 0.8;}
      }
    }
  }
}
</style>
